import { Pills } from 'components/common/pills/pills';
import classes from 'components/widgets/RenderLibraryTable/components/ProgramTags/programTags.module.scss';
import { CustomizedRoundIcon, CustomizedTooltip } from 'components/common';
import { MuiIcon } from 'components/common/muiIcon/muiIcon';
import React from 'react';
import { Link } from 'react-router-dom';
import { projectConfig } from 'components/Dashboards/Project/ProjectWrapper/projectConfig';
import { orderBy } from 'lodash';
import { QueryResponse } from 'api/queries/getTagsPerContract.query';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

interface Props {
    list?: QueryResponse[];
}

export const ProgramTags = ({ list }: Props) => {
    return (
        <div className={classes.container}>
            Program Tags:{' '}
            {orderBy(list, [(item) => item.name.toLowerCase()], ['asc'])?.map((item) => (
                <Pills key={item.id} type={'tag'}>
                    {item.name}
                </Pills>
            ))}
            <CustomizedTooltip
                tooltipContent={'Edit Tags'}
                triggerElement={
                    <Link
                        to={AppRoutes.buildPath(
                            AppRoutes.DASHBOARD_PROJECT_PATH,
                            projectConfig.programLibrary.link,
                            projectConfig.subProgramPreferences.link,
                        )}
                    >
                        <CustomizedRoundIcon data-testid={'edit-tags'} size={'3.6rem'}>
                            <MuiIcon icon={'edit'} fontSize={'1.8rem'} />
                        </CustomizedRoundIcon>
                    </Link>
                }
            />
        </div>
    );
};
